/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const sidenavTokens = {
  FontColorBaseDefault: '#1c2222',
  TransitionCurveBaseDefault: 'cubic-bezier(0, 0.405, 0, 1)',
  TransitionDurationBaseDefault: '0.5s',
  FilterBorderColorBaseDefault: '#dedfdf',
  FilterBackgroundColorBaseDefault: '#ffffff',
  FilterBackgroundColorBaseKeyboardFocus: '#ffffff',
  FilterPlaceholderFontColorBaseDefault: '#7b8080',
  FilterFontLeadingBaseDefault: '20px',
  FilterFontSizeBaseDefault: '13px',
  FilterPaddingBaseDefault: '4px 4px 4px 12px',
  GroupContainerBackgroundColorBaseHighlighted: '#e2d5c2',
  GroupContainerTransitionBaseDefault: 'background-color 1s ease-out',
  GroupToggleBorderRadiusBaseDefault: '4px',
  GroupToggleMarginBaseClosedVertical: '6px',
  GroupToggleMarginBaseClosedHorizontal: '16px',
  GroupToggleMarginBaseOpenHorizontal: '10px',
  GroupTogglePaddingBaseClosed: '4px',
  GroupTogglePaddingBaseOpen: '8px 10px',
  GroupToggleFontWeightBaseDefault: '500',
  GroupToggleFontLeadingBaseDefault: '24px',
  GroupToggleBackgroundColorBaseHover: '#f0eae1',
  GroupItemPaddingBaseVertical: '6px',
  GroupItemPaddingBaseHorizontal: '20px',
  GroupItemPaddingRightVisibleFocus: '10px',
  GroupItemMarginLeftBaseDefault: '29px',
  GroupItemMarginRightVisibleFocus: '10px',
  GroupItemBorderRadiusVisibleFocus: '4px',
  GroupItemFontWeightBaseDefault: '400',
  GroupItemFontWeightBaseActive: '600',
  GroupItemLabelMaxWidthBaseDefault: '143px',
  IconBorderRadiusBaseDefault: '5px',
  IconMarginRightBaseOpen: '10px',
  IconBackgroundColorActiveDefault: '#e2d5c2',
  IconBackgroundColorBaseHover: '#f0eae1',
  IconBadgePositionTopBaseDefault: '-1px',
  IconBadgePositionRightBaseDefault: '-1px',
  IconBadgeDimensionBaseDefault: '8px',
  IconBadgeBackgroundColorBaseDefault: '#ea957b',
  IconBadgeBorderRadiusBaseDefault: '4px',
  IconBadgeTransitionDelayBaseDefault: '0.175s',
  ItemBackgroundColorActiveDefault: '#ffffff',
  ItemBackgroundColorActiveHover: '#f0eae1',
  ItemBackgroundColorBaseHover: '#f0eae1',
  ItemSpacingPaddingVerticalBaseDefault: '22px',
  ItemSpacingPaddingHorizontalBaseDefault: '20px',
  ItemSpacingGapHorizontalBaseDefault: '8px',
  ItemBorderStyleBaseDefault: 'solid',
  ItemBorderWidthBaseDefault: '1px',
  ItemBorderWidthBaseDown: '4px',
  ItemBorderColorBaseDefault: '#dedfdf',
  ItemBorderColorBaseDown: '#e57b5a',
  ItemPaddingBaseClosed: '4px',
  ItemPaddingBaseOpenVertical: '8px',
  ItemPaddingBaseOpenHorizontal: '10px',
  ItemFontSizeBaseDefault: '14px',
  ItemFontWeightBaseDefault: '500',
  ItemFontWeightBaseActive: '600',
  ItemFontLeadingBaseDefault: '24px',
  SectionLabelFontColorBaseDefault: '#8d8d8d',
  SectionLabelFontSizeBaseDefault: '12px',
  SectionLabelBorderTopBaseDefault: '1px solid #E6E6E6',
  SectionLabelPaddingVerticalBaseOpen: '16px',
  SectionLabelPaddingVerticalBaseClosed: '8px',
  SectionLabelMarginBaseOpen: '16px 20px 4px',
  SectionLabelMarginBaseClosed: '4px 0',
  StickyContainerTopHeightBaseDefault: '52px',
  StickyContainerTopMarginBottomBaseDefault: '10px',
  StickyContainerTopPaddingBaseDefaultVertical: '12px',
  StickyContainerTopPaddingBaseDefaultHorizontal: '16px',
  StickyContainerBorderBaseVisible: '1px solid rgba(230,230,230,1)',
  StickyContainerBorderBaseHidden: '1px solid rgba(230,230,230,0)',
  StickyContainerBoxShadowOffsetXBaseVisible: '0',
  StickyContainerBoxShadowOffsetXBaseHidden: '0',
  StickyContainerBoxShadowOffsetYBaseVisible: '1px',
  StickyContainerBoxShadowOffsetYBaseHidden: '0',
  StickyContainerBoxShadowBlurBaseVisible: '8px',
  StickyContainerBoxShadowBlurBaseHidden: '0',
  StickyContainerBoxShadowColorBaseVisible: 'rgba(230,230,230,0.5)',
  StickyContainerBoxShadowColorBaseHidden: 'rgba(230,230,230,0)',
  ToggleBackgroundColorBaseHover: '#dedfdf',
  ToggleBorderRadiusBaseDefault: '4px',
  TogglePaddingBaseDefaultVertical: '4px',
  TogglePaddingBaseDefaultHorizontal: '6px',
  TwiddleFontColorBaseDefault: '#7b8080',
  TwiddleFontColorBaseHover: '#000000',
  NewTabFontColorBaseDefault: '#a7aaaa',
  NewTabFontWeightBaseDefault: '300',
  NewTabFontSizeBaseDefault: '13px',
  WrapperColorBackgroundBaseDefault: '#fbf8f7',
  WrapperBorderBaseVisible: '1px solid rgba(230,230,230,1)',
  WrapperBorderBaseHidden: '1px solid rgba(230,230,230,0)',
  WrapperWidthBaseClosed: '60px',
  WrapperWidthBaseOpen: '240px',
  WrapperWidthMobileOpen: 'calc(100vw)',
  WrapperPaddingTopBaseOpen: '8px',
  WrapperPaddingTopBaseClosed: '62px',
  WrapperPaddingBottomBaseDefault: '40px',
  WrapperElevationCompactDefault: '21',
} as const;
